import React from 'react';
import { PageHeader } from '../components/layout/PageHeader';
import { Steps } from '../components/home/Steps';
import { CtaBand } from '../components/ui/CtaBand';
import { SectionHeading } from '../components/ui/SectionHeading';
import { FaqList } from '../components/ui/FaqList';
import { faqs } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { useBrand } from '../contexts/BrandContext';
const accommodations = [{
  title: 'One question at a time',
  detail: 'The intake is five questions on five screens, not a twelve-page form. You can skip almost all of them and still be seen.'
}, {
  title: 'Nothing is lost',
  detail: 'Your symptom selections stay with you across the visit. Close the tab, sleep on it, come back — you will not start over.'
}, {
  title: 'No gate on answers',
  detail: 'The decoder, the library and the stage guide are free and require no account. Withholding an answer from this audience is the exact harm we exist to fix.'
}, {
  title: 'No urgency, anywhere',
  detail: 'No countdown timers, no scarcity, no pop-ups, no chat bubble ambush. One primary action per screen and nothing that manufactures panic.'
}, {
  title: 'Errors are our fault',
  detail: 'If something goes wrong or a link is broken, we say so in those words. Nothing on this site is written to imply you should have caught this sooner.'
}, {
  title: 'Leaving is two clicks',
  detail: 'Cancel from your account without a retention call, an exit survey you cannot skip, or a discount that only appears at the door.'
}];
export function HowItWorks() {
  const {
    brand
  } = useBrand();
  useDocumentMeta({
    title: `How it works — ${brand.name}`,
    description: 'Five questions, a clinician who reads them before you meet, testing only where it changes the plan, and treatment titrated to how you feel.'
  });
  return <main className="w-full bg-cream" data-id="element-590" data-mp="2pdc6fa3jcdlc">
      <PageHeader eyebrow="How it works" title="Built for someone with no energy to spare." intro="You do not need a symptom diary, a diagnosis, or the right vocabulary. You need about four minutes and one thing that is bothering you." data-id="element-591" data-mp="38jidp9awctmx" />

      <Steps data-id="element-592" data-mp="2zhiwafvyznjg" />

      <section className="bg-cream" data-id="element-593" data-mp="34i6vvpy9lcpa">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-24" data-id="element-594" data-mp="34j88vzyuc99n">
          <SectionHeading eyebrow="Designed on purpose" title="The parts you are not supposed to notice." intro="Most health sites are built to convert someone with energy. This one is built for a woman reading it at 2am on her fourth night of broken sleep." data-id="element-595" data-mp="3s7hnagtq5uqr" />
          <ul className="mt-14 grid gap-px overflow-hidden rounded-brand border border-ink/15 bg-ink/15 md:grid-cols-2 xl:grid-cols-3" data-id="element-596" data-mp="3n853y622b5sx">
            {accommodations.map(item => <li key={item.title} className="bg-cream-light p-8" data-id="element-597" data-mp="2buaqlwumqcgw">
                <h3 className="font-serif text-2xl leading-snug text-ink" data-id="element-598" data-mp="2breso8is7nsg">{item.title}</h3>
                <p className="mt-4 leading-relaxed text-ink-soft" data-id="element-599" data-mp="24ccxv40o3g0d">{item.detail}</p>
              </li>)}
          </ul>
        </div>
      </section>

      <section className="bg-cream-light" data-id="element-600" data-mp="2d9vlmg5p48fy">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-24" data-id="element-601" data-mp="2d8u7u3xap7uj">
          <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-602" data-mp="28cdb4lc15l5u">
            <SectionHeading eyebrow="Before you start" title="Asked constantly, answered plainly." data-id="element-603" data-mp="1knav1hx1o0dg" />
            <div data-id="element-604" data-mp="1glpbxetx2put">
              <FaqList items={faqs} data-id="element-605" data-mp="1gm8tgufnnc8b" />
            </div>
          </div>
        </div>
      </section>

      <CtaBand data-id="element-606" data-mp="1udndn4latjgy" />
    </main>;
}